var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 530,
    height: 129,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 265,
    cy: 40,
    rx: 264.5,
    ry: 39.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 265,
    cy: 52,
    rx: 264.5,
    ry: 39.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 265,
    cy: 65,
    rx: 264.5,
    ry: 39.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 265,
    cy: 77,
    rx: 264.5,
    ry: 39.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 265,
    cy: 89,
    rx: 264.5,
    ry: 39.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternRings);
export default __webpack_public_path__ + "static/media/pattern-rings.e62a24d55bee668faa1f245882fad1b7.svg";
export { ForwardRef as ReactComponent };